(() => {
 function initialize(root){
  if(root.dataset.galleryReady)return;root.dataset.galleryReady='true';
  const thumbnails=[...root.querySelectorAll('[data-gallery-index]')],image=root.querySelector('#product-photo'),count=root.querySelector('.gallery-count'),dialog=root.querySelector('.gallery-lightbox');
  let selected=0,video=null;
  const filmThumb=thumbnails.find(t=>t.dataset.galleryVideo);
  if(filmThumb){
   video=document.createElement('video');video.muted=true;video.loop=true;video.playsInline=true;video.preload='none';video.setAttribute('playsinline','');video.setAttribute('muted','');video.setAttribute('aria-label',filmThumb.dataset.galleryAlt||'Product film');
   video.poster=filmThumb.dataset.gallerySrc;video.dataset.src=filmThumb.dataset.galleryVideo;video.src=filmThumb.dataset.galleryVideo;video.hidden=true;
   video.addEventListener('canplay',()=>{if(!video.hidden&&video.paused)video.play().catch(()=>{});});
   image.after(video);
   const warm=()=>{video.preload='auto';video.load();};
   if(document.readyState==='complete')setTimeout(warm,300);else addEventListener('load',()=>setTimeout(warm,300),{once:true});
  }
  const syncDialog=()=>{const t=thumbnails[selected],film=t.dataset.galleryVideo,dimg=dialog.querySelector('img');let dv=dialog.querySelector('video');
   if(film){if(!dv){dv=document.createElement('video');dv.muted=true;dv.loop=true;dv.playsInline=true;dv.controls=true;dv.setAttribute('playsinline','');dv.setAttribute('muted','');dimg.after(dv);}dv.poster=t.dataset.gallerySrc;if(dv.dataset.src!==film){dv.dataset.src=film;dv.src=film;}dimg.hidden=true;dv.hidden=false;dv.play().catch(()=>{});}
   else{if(dv){dv.pause();dv.hidden=true;}dimg.hidden=false;dimg.src=image.src;dimg.alt=image.alt;}};
  function show(index,focus=false){
   selected=(index+thumbnails.length)%thumbnails.length;
   const t=thumbnails[selected],film=t.dataset.galleryVideo;
   if(film){
    image.hidden=true;video.hidden=false;video.play().catch(()=>{});
   }else{
    if(video){video.pause();video.hidden=true;}
    image.hidden=false;image.src=t.dataset.gallerySrc;
    image.alt=t.dataset.galleryAlt||`Better Coffee Booster product image ${selected+1} of ${thumbnails.length}`;
   }
   count.textContent=`${selected+1} / ${thumbnails.length}`;
   thumbnails.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===selected)));
   const strip=root.querySelector('.gallery-thumbnails'),button=thumbnails[selected];
   if(button.offsetLeft<strip.scrollLeft||button.offsetLeft+button.offsetWidth>strip.scrollLeft+strip.clientWidth)strip.scrollLeft=button.offsetLeft-strip.clientWidth/2+button.offsetWidth/2;
   if(focus)button.focus({preventScroll:true});
   if(dialog.open)syncDialog();
  }
  thumbnails.forEach((button,index)=>button.addEventListener('click',()=>show(index)));
  root.querySelector('[data-gallery-prev]').addEventListener('click',()=>show(selected-1));
  root.querySelector('[data-gallery-next]').addEventListener('click',()=>show(selected+1));
  root.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'||event.key==='ArrowRight'){event.preventDefault();show(selected+(event.key==='ArrowRight'?1:-1),!dialog.open);}});
  root.querySelector('[data-gallery-open]').addEventListener('click',()=>{syncDialog();dialog.showModal();});
  root.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());
  dialog.addEventListener('close',()=>{dialog.querySelector('video')?.pause();root.querySelector('[data-gallery-open]').focus({preventScroll:true});});

 }
 window.BetterGallery={initialize};
 document.querySelectorAll('[data-product-gallery]').forEach(initialize);
})();
